import { render, staticRenderFns } from "./cardCollapseDocs.vue?vue&type=template&id=e1e7f2e4&scoped=true"
import script from "./cardCollapseDocs.vue?vue&type=script&lang=js"
export * from "./cardCollapseDocs.vue?vue&type=script&lang=js"
import style0 from "./cardCollapseDocs.vue?vue&type=style&index=0&id=e1e7f2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e7f2e4",
  null
  
)

export default component.exports